/*
 * Event Service.
 */

/**
 * REST CLIENT PER WS DI GESTIONE DEL SITUATION RECORD
 */
'use strict';
module.exports = ['$rootScope', '$resource', '$httpParamSerializerJQLike'
            , function ($rootScope, $resource, $httpParamSerializerJQLike) {

                var mainConfig = global.ngDroAstralSituationRecordMainConfig;
                var validityPeriodEndDateNullValue = moment.utc(mainConfig.ValidityPeriodEndDateNullValue, "YYYY-MM-DD  HH:mm:ss");

                var baseEndPointUrl = mainConfig.ApiUrl;
                var baseEndPointPublicUrl = mainConfig.PublicApiUrl;

                var situationRecordTemplateEndPointUrl = baseEndPointUrl + 'situation-record-template/';
                return $resource(baseEndPointUrl, {},
                        {
                            'create': {
                                method: 'POST',
                                url: situationRecordTemplateEndPointUrl,
                                withCredentials: true,
                                transformRequest: function (data) {
                                    data.situationRecord.id=undefined;
                                    data.situationRecord.isTemplate=true;
                                    var json = angular.toJson(data);
                                    return json;
                                }
                            },
                            'update': {
                                method: 'PUT',
                                url: situationRecordTemplateEndPointUrl,
                                withCredentials: true,
                                transformRequest: function (data) {
                                    data.situationRecord.id=data.template.situationRecordId;
                                    data.situationRecord.isTemplate=true;
                                    var json = angular.toJson(data);
                                    return json;
                                }
                            }, 'getAll': {
                                method: 'GET',
                                url: situationRecordTemplateEndPointUrl,
                                withCredentials: true,
                                isArray: true,
                                params: {
                                    page: '@page',
                                    size: '@size',
                                    sort: '@sort'
                                }
                            }, 'get': {
                                method: 'GET',
                                url: situationRecordTemplateEndPointUrl + ':id',
                                withCredentials: true,
                                params: {
                                    id: '@id'
                                }
                                
                            },
                            'delete': {
                                method: 'DELETE',
                                url: situationRecordTemplateEndPointUrl + ':id',
                                withCredentials: true,
                                params: {
                                    id: '@id'
                                }
                            }, 'getDetails': {
                                method: 'GET',
                                url: situationRecordTemplateEndPointUrl + 'get-details',
                                withCredentials: true,    
                                //isArray: true,
                                params: {
                                    page: '@page',
                                    size: '@size',
                                    sort: '@sort'
                                }
                            },
                            'createFromTemplate': {
                                method: 'POST',
                                url: situationRecordTemplateEndPointUrl + 'create-from-template/:id',
                                withCredentials: true,
                                params: {
                                    id: '@id'
                                },
                                transformResponse: function (data) {
          
                                    var response = angular.fromJson(data);
                                    
                                    if (response.validityPeriods && response.validityPeriods != null) {
                                        angular.forEach(response.validityPeriods, function (period) {
                                            var dateEnd = moment.utc(period.dateEnd, "YYYY-MM-DD  HH:mm:ss");
                                            if (moment(dateEnd).isSame(validityPeriodEndDateNullValue)) {
                                                period.dateEnd = null;
                                            }
                                        });
                                    }
                                    return response;
                                }
                            }, 'getDetail': {
                                method: 'GET',
                                url: situationRecordTemplateEndPointUrl + ':id/get-detail',
                                withCredentials: true,
                                params: {
                                    id: '@id'
                                },
                                transformResponse: function (data) {
          
                                    var response = angular.fromJson(data);
                                    
                                    if (response.validityPeriods && response.validityPeriods != null) {
                                        angular.forEach(response.validityPeriods, function (period) {
                                            var dateEnd = moment.utc(period.dateEnd, "YYYY-MM-DD  HH:mm:ss");
                                            if (moment(dateEnd).isSame(validityPeriodEndDateNullValue)) {
                                                period.dateEnd = null;
                                            }
                                        });
                                    }
                                    return response;
                                }
                                
                            },
                             'search': {
                                method: 'POST',
                                url: situationRecordTemplateEndPointUrl + 'search',
                                withCredentials: true,
                                data: {
                                    clazz: "com.dromedian.jdro.datex2.domain.SituationRecordFilterEntity",
                                    id: null,
                                    validityPeriodsDateStart: '@validityPeriodsDateStart',
                                    validityPeriodsDateEnd: '@validityPeriodsDateEnd',
                                    topLeft: '@topLeft',
                                    bottomRight: '@bottomRight',
                                    eventTypeList: '@eventTypeList',
                                    createdDateStart: '@createdDateStart',
                                    createdDateEnd: '@createdDateEnd',
                                    severity: '@severity',
                                    validityStatus: '@validityStatus',
                                    probabilityOfOccurrence: '@probabilityOfOccurrence',
                                    confidentiality: '@confidentiality',
                                    cause: '@cause',
                                    sourceList: '@sourceList',
                                    comment: '@comment',
                                    publicSiteEvidence: '@publicSiteEvidence',
                                    isTemplate: '@isTemplate'
                                },
                                params: {
                                    page: '@page',
                                    size: '@size',
                                    sort: '@sort'
                                }
                            }
                          
                        });
            }];




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/services/situationRecordTemplateService.js
// module id = 258
// module chunks = 0